import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { Col, Row } from "react-styled-flexboxgrid";
import PageSection, { StyledSectionHeading } from "../components/PageSection";
import { siteTitle } from "../data/PublicSiteData";
import { trackPageView } from "../includes/analytics";
import Public from "../Layouts/Public";
import { Color } from "../theme/Color";

const Terms = () => {
  const router = useRouter();

  trackPageView("/terms-of-use");

  return (
    <>
      <NextSeo
        title={`Terms of use | ${siteTitle}`}
        description="Valmeego is a new way for destinations and visitors to interact online.
Get inspiration, local knowledge, advice & deals directly from any destination."
      />
      <PageSection
        backgroundColor={Color.White}
        width="1340px"
        data-cy="core-values"
      >
        <StyledSectionHeading center="xs">Terms of use</StyledSectionHeading>
        <Row center="xs" middle="xs">
          <Col
            xs={10}
            md={8}
            style={{ color: Color.Grey2, marginBottom: "5rem" }}
          >
            <p>
              <i>Last Updated: 21/07/2022</i>
            </p>
            <p>
              Please read these terms and conditions carefully before using Our
              Service.
            </p>
            <p>
              These are the Terms and Conditions governing the use of
              Valmeego.com (website or application), and the agreement that
              operates between You and the Company. These Terms and Conditions
              set out the rights and obligations of all users regarding the use
              of the Service.
            </p>
            <p>
              Your access to and use of the Service is conditioned on Your
              acceptance of and compliance with these Terms and Conditions.
              These Terms and Conditions apply to all visitors, users and others
              who access or use the Service.
            </p>
            <p>
              By accessing or using the Service You agree to be bound by these
              Terms and Conditions. If You disagree with any part of these Terms
              and Conditions then You may not access the Service.
            </p>
            <p>You represent that you are over the age of 16. </p>
            <p>
              Your access to and use of the Service is also conditioned on Your
              acceptance of and compliance with the Privacy Policy of the
              Company. Our Privacy Policy describes Our policies and procedures
              on the collection, use and disclosure of Your personal information
              when You use the Application or the Website and tells You about
              Your privacy rights and how the law protects You. Please read Our
              Privacy Policy carefully before using Our Service.
            </p>
            <p>
              By accepting these Terms, you agree to be bound by these Terms.
            </p>

            <h2>A. General Terms</h2>
            <h2>A1. Definitions</h2>
            <p>
              <i>"Third Party Providers"</i> are independent third parties and
              include, but are not limited to, independent service providers,
              accommodation providers, tour providers, Activity providers,
              restaurants, and/ or providers of mobility services.
            </p>
            <p>
              <i>"Third Party Services"</i> include, but are not limited to,
              services and goods in the field of travel, hospitality, mobility,
              activities, grocery, and retail industries, provided to you by
              independent Third-Party Providers, such as, but not limited to,
              accommodation services. These are made available to you through
              the use of the application/ Website Services, as defined below.{" "}
            </p>
            <p>
              <i>"Travel Ecosystem"</i> A network of travel destinations
              connected bringing economic benefits to their community. A travel
              destination is the combination of all the things to see and do,
              supported by the infrastructure of where to stay, where to eat,
              and how to get around.
            </p>
            <p>
              <i>"Valmeego"</i> means Valmeego.com or any of its subsidiaries or
              affiliates (‘we’ or ‘us’).
            </p>
            <p>
              <i>"Valmeego Provided Services"</i> means services provided
              directly to you by Valmeego which may be subject to separate terms
              between you and us. These may include, but are not limited to,
              travel services under the Valmeego brand.
            </p>
            <p>
              <i>"Trip Planner"</i> person who organises, plans and/or books a
              trip on our platform.
            </p>
            <p>
              <i>"Ameego"</i> means a person with in-depth knowledge of a
              destination or specific activity, who provide recommendations,
              advice and tips on the local area.
            </p>
            <p>
              <i>"Valmeego names, marks"</i>means Valmeego or its licensor’s
              company names, logos, products, or service names, trademarks,
              service marks, trade dress, other indicia or ownership, or
              copyrights.
            </p>
            <p>
              <i>"Account"</i> means an account (on Valmeego.com), through which
              you can plan and book Travel experiences on our platform.
            </p>
            <p>
              <i>"Booking"</i> means the booking of a Travel experience on our
              platform, whether you pay for it now or later.
            </p>
            <p>
              <i>"Booking confirmation"</i> means the voucher or ticket sent to
              your account, explaining the details of your booking.
            </p>
            <p>
              <i>"Valmeego.com"</i>, ‘us’, ‘we’ or ‘our’ means Valmeego.com{" "}
            </p>
            <p>
              <i>"Personal Wallet"</i> our platform provides a personal wallet
              with each account created.
            </p>
            <p>
              <i>"Trip Wallet"</i> means a wallet is provided with each trip
              created in your account, for trip expenses.
            </p>
            <p>
              <i>"Pay In Your Own Currency"</i> means the payment option that we
              sometimes offer when a Service Provider doesn’t use your currency.
              This option lets you pay in your currency instead.
            </p>
            <p>
              <i>"Payment Method"</i> means the method (credit card, debit card,
              bank account, Valmeego wallet etc.) used to make a payment or
              transfer money.
            </p>
            <p>
              <i>"Our Services"</i> means the services provided on our platform.
            </p>
            <p>
              <i>"Platform"</i> means the website/ app on which you can use our
              services.
            </p>
            <p>
              <i>"Service Provider"</i> means the provider of a travel-related
              product or service on the platform.
            </p>
            <p>
              <i>"Terms"</i> means the terms of use.
            </p>
            <p>
              <i>"Travel Experience"</i> means one of the travel-related
              products or services on the platform (accommodation, activities
              services).
            </p>
            <p>
              <i>"Accommodation"</i> means the provision of an accommodation
              service by a service provider.
            </p>
            <p>
              <i>"Attraction"</i> means the provision of an attraction service
              by a service provider.
            </p>
            <p>
              <i>"Attraction service(s)"</i>, includes but is not limited to,
              tours, attractions, activities, and experiences.
            </p>
            <p>
              <i>"Credits"</i> means a benefit with a monetary value. There are
              ‘Cash Credits’ and ‘Travel Credits’.
            </p>
            <p>
              <i>"Travel Credits"</i> means a benefit with a monetary value that
              you can put towards the cost of a future Travel Experience but
              can’t ‘cash out’.
            </p>
            <p>
              <i>"Upfront Payment"</i> means a payment that you make when you
              book a product or service (rather than when you actually use it).
            </p>
            <p>
              <i>"Rewards"</i> means a benefit that you are promised.
            </p>
            <p>
              <i>"Individual Reward Criteria"</i>means rules that apply to
              certain Rewards.
            </p>
            <p>
              <i>"PWA"</i> means a progressive web application.
            </p>

            <h2>A2. Terms</h2>
            <ol>
              <li>
                When you use Valmeego’s services, you accept these Terms and any
                other terms that you’ve been provided with during the process.
              </li>

              <li>
                If anything in these Terms is (or becomes) invalid, or
                unenforceable:
                <ul>
                  <li>
                    It will still be enforced to the fullest extent permitted by
                    law.
                  </li>
                  <li>
                    You will still be bound by everything else in the ‘Terms’.
                  </li>
                </ul>
              </li>

              <li>
                These Terms are laid out like this:
                <ul>
                  <li>
                    Section A: General terms, for all types of Travel
                    Experiences
                  </li>
                  <li>Section B: Products and Services (commitments) </li>
                  <li>Section C: Service Providers</li>
                </ul>
              </li>
              <li>
                If there is any mismatch between general and specific terms, the
                specific terms will apply.
              </li>
            </ol>

            <h2>A3. About Valmeego.com</h2>
            <p>
              Valmeego’s platform enables travellers to connect with each other,
              build travel ecosystems, and travel with knowledge. These Terms
              govern your use of Valmeego, our services, features, applications
              and technologies.
            </p>
            <p>
              When you book services through Valmeego’s travel feed,
              Valmeego.com provides and is responsible for the platform- but not
              the Travel Experience itself.{" "}
            </p>
            <p>
              We don’t charge you to use Valmeego, or the products and services
              covered by these Terms. Instead, businesses provide and advertise
              their services on our platform. By using our products and services
              you agree that we can show you ads and deals that we think will be
              relevant to you and your interests. We use a personal
              recommendation system and your personal data to help determine
              which advertisements to show you.
            </p>
            <p>
              We don’t provide your personal data to advertisers unless you have
              granted us permission. Instead, advertisers can tell us the type
              of audience they want to see their ads. Our privacy policy
              explains how we collect and use your personal data to determine
              the ads you see and provide the other services described below.{" "}
            </p>

            <h2>A4. Our Platform</h2>
            <p>
              We take reasonable care in providing our Platform, but we cannot
              guarantee that every piece of information is accurate (we receive
              information from Service providers). To the extent permitted by
              law, we cannot be held responsible for any errors, or missing bits
              of information. We will correct and fix them as soon as we can.
            </p>
            <p>
              Valmeego platform provides a personal recommendation model
              enabling users to provide a link to a good service with their
              friends. We’re not a party to the terms between you and the
              service provider. The service provider is solely responsible for
              the Travel Experience.
            </p>
            <p>
              To create and organise a trip and/or make a booking, you will need
              to create an account. Please make sure all your personal
              information (including payment and contact details) are correct
              and up to date. You are responsible for anything that happens with
              your account, please keep your username and password secret.
            </p>
            <p>
              Unless otherwise indicated, you need to be at least 16 to use the
              platform.
            </p>

            <h2>A5. Our Values</h2>

            <p>You will:</p>
            <p>Abide by our values.</p>
            <p>
              Valmeego aims to provide an online travel environment where people
              conduct themselves is a respectful, honest manner. We intend to
              bring the human touch back into the online travel market. Valmeego
              users are expected to be friendly, and courteous in their manner
              and to have integrity, fairness, and honour in their dealings with
              each other.
            </p>
            <ul>
              <li>Comply with all applicable laws</li>
              <li>
                Cooperate with any anti-fraud, anti-money laundering checks we
                may carry out.
              </li>
              <li>Not use the platform to make fake trips or bookings.</li>
              <li>
                Not cause any nuisance or behave inappropriately to any Valmeego
                members.
              </li>
            </ul>

            <h2>A6. Prices</h2>
            <p>Valmeego is free to join and use.</p>
            <p>
              When you make a booking on Valmeego, you agree to pay the cost of
              the Travel experience, including any charges and taxes that may
              apply. Some of the prices you see may have been rounded to the
              nearest whole number. The price you pay will be based on the
              original, ‘non-rounded’ price.
            </p>
            <p>
              Obvious errors and misprints are not binding. For example, if you
              book a luxury suite that was mistakenly offered for €5, we may
              simply cancel that booking and refund anything you paid.
            </p>
            <p>
              Service Providers have the right to choose the cost of their
              products and services.{" "}
            </p>

            <h2>A7. Payment</h2>
            <p>
              For some products and services, the Service Providers will require
              an Upfront Payment and/or a payment taken during your Travel
              Experience.{" "}
            </p>
            <p>
              If the service provider requires an upfront payment, it may be
              taken or pre-authorised when you make a booking, and it may be
              non-refundable. Before you book, please check the Service
              providers upfront payment policy (available during the booking
              process) which we don’t influence and aren’t responsible for.
            </p>
            <p>
              Valmeego uses Stripes Online payment processor to hold your card
              details and payments made through Valmeego. Valmeego does not
              store or manage transactions made through Valmeego.com.
            </p>
            <p>
              If you know of or suspect any fraud or unauthorised use of your
              payment method, please contact your payment provider, who may
              cover any resulting charges, possibly minus an excess.
            </p>
            <p>
              If the currency selected on the platform isn’t the same as the
              Service Providers currency, we may:
              <ul>
                <li>Show prices in your own currency.</li>
                <li>Offer you the ‘Pay in your own currency’ option.</li>
              </ul>
            </p>
            <p>
              You’ll see our Currency Conversion Rate during checkout. If we
              charge you fees in connection wit any such services, you’ll find
              the fee expressed as a percentage over European Central Bank
              rates.{" "}
            </p>

            <h2>A8. Policies</h2>
            <p>
              When you use Valmeego’s platform and make a booking, you accept
              the applicable policies as displayed. You’ll find each Service
              providers cancellation policy and any other policies (about age
              requirements, security, damage deposits, etc) on our platform: on
              the Service provider profile page, during the booking process, in
              the fine print, and/ or in the confirmation ticket (if
              applicable).
            </p>
            <p>
              If you cancel a booking, reservation, or don’t show up any
              cancellation/ no-show fee and any refund will depend on the
              Service Provider’s cancellation/ no-show policy. Some bookings
              can’t be cancelled for free, while others can be cancelled for
              free before a deadline.
            </p>
            <p>
              If you book a Travel experience by paying in advance (including
              all price components and/ or a damage deposit if applicable), the
              Service Provider may cancel the booking without notice if they
              can’t collect the balance on the date specified. If they do, any
              non-refundable payment you’ve made will only be refunded at their
              discretion. It’s your responsibility to make sure the payment goes
              ahead on time, (that your bank, debit card or credit card details
              are correct, and/ or that there’s enough money available in your
              Valmeego wallet).
            </p>
            <p>
              If you think you’re not going to arrive in time, please contact
              your Service provider and tell them when they can expect you, so
              they don’t cancel your Booking. If you’re late, we are not liable
              for the consequences (e.g., the cancellation of your booking, or
              any fees the Service Provider may charge).
            </p>
            <p>
              As the person making the booking (trip planner), you are
              responsible for the actions and behaviour (in relation to the
              travel experience) of everyone in the group. You are also
              responsible for obtaining their permission before providing us
              with their personal data.{" "}
            </p>
            <p>
              Our Data Policy explains how we collect and use your personal data
              to determine some of the ads you see and provide all of the other
              services described below. You can also go to your settings at any
              time to review the privacy choices you have about how we use your
              data.
            </p>
            <p>
              If you use Valmeego’s platform, you must adhere to our policies,
              for example- Ecosystem standards, commercial terms, advertising
              policies, etc.
            </p>

            <h2>A9. Privacy and cookies</h2>
            <p>
              If you create an account on Valmeego, or make a booking, please
              see our Privacy and Cookie Policies for more information on
              privacy, cookies and how we may contact you and process your
              personal data.
            </p>

            <h2>A10. Accessibility Requests</h2>
            <p>If you have any accessibility requests:</p>
            <ul>
              <li>
                About our platform and/or services please contact our Customer
                Service team.
              </li>
              <li>
                About your Travel Experience, filter’s can be accessed in the
                travel feed, or through direct contact with the service
                provider- Valmeego provides a direct chat contact.{" "}
              </li>
            </ul>

            <h2>A11. Insurance</h2>
            <p>
              If you have bought insurance through our platform, please refer to
              the policy document(s) for the terms and for further information.
              These Terms do not apply to insurance.
            </p>

            <h2>A12. Credits, Rewards and Valmeego's Wallet</h2>
            <h3>1. Credits</h3>
            <p>
              Travel Credits will be issued to an individual if they fit the
              individual credit criteria that apply. If we make a clerical error
              (i) in calculating your credit or (ii) in converting currencies
              related to your credits, we can always change, or correct balances
              shown.{" "}
            </p>
            <p>
              <b>How to get credits. </b> Travel Credits are usually issued when
              a cancellation is made, you can use these to book another service
              through Valmeego’s platform. We may issue credits for other
              reasons- for example, if your Travel experience didn’t live up to
              our usual high standards.
            </p>
            <p>
              <b>Where to find your credits. </b> Once you have received some
              credits, you will find them stored in your wallet in your
              Valmeego.com account. On the ‘wallet’ feature you can view all
              your transactions made, you will see when credits were received
              and spent, and when they expire. If you have cash credits, you
              will be able to cash them out via stripe.
            </p>
            <p>
              <b>Types of credits. </b> Travel credits can only be spent on
              Travel experiences advertised on our platform. Cash credits can be
              cashed out of your wallet or spent on any travel experience that
              you can pay for using travel credits.
            </p>

            <h3>2. Rewards</h3>
            <p>
              We may issue Rewards to you- at our sole discretion and (a)subject
              to the terms here in A13 and (b) individual Reward Criteria that
              apply. If we make a clerical error (i) in calculating your reward
              or (ii) in converting currencies related to your reward, we can
              always change, or correct balances shown.{" "}
            </p>
            <p>
              <b>How to get rewards. </b>. You might, for example get a reward
              by making a certain number of bookings in a given time period.
              Services you have used might present you with a personalised deal
              as a reward for loyalty and repeat business. When a reward is
              available, we’ll explain what the specific conditions are and how
              to use it.
            </p>
            <p>
              <b>Where to find your Rewards. </b>. Once you have received one or
              more rewards, you will find a notification on your account and/ or
              a message from the service provider with a link of the reward. You
              will see the reward you’ve earned, what actions still need to be
              taken to obtain the reward(s0), and any other terms and
              conditions.
            </p>
            <p>
              <b>Type of rewards. </b>You might receive Credits, deals,
              discounts, verification, or something different. We’ll explain
              each reward at the appropriate time.
            </p>
            <p>
              {" "}
              To receive any type of rewards, you must when qualifying for and
              using the credits:
            </p>
            <ul>
              <li>Have an account on Valmeego</li>
              <li>Be at least 16 years old</li>
              <li>Meet the individual reward criteria</li>
              <li>Not violate the rewards & wallet terms.</li>
              <li>
                Have a valid credit card, to qualify for cashback rewards.
              </li>
            </ul>

            <p>
              When a reward is available, the individual reward criteria will
              explain how you can qualify for it. There may be:
            </p>
            <ul>
              <li>
                Time-sensitive restrictions (e.g. Offers with expiry dates)
              </li>
              <li>
                Platform restrictions (e.g. Promotional codes that can only be
                used in our platform)
              </li>
              <li>
                Property restrictions (e.g. Offers that can only be used with
                specific service providers)
              </li>
              <li>
                A Minimum spend (e.g. Reward that you’ll only learn when you
                spend at least a certain amount on a booking)
              </li>
              <li>
                Maximum reward value (for either monetary or non-monetary
                rewards)
              </li>
            </ul>
            <p>
              Rewards cannot be sold, encumbered, or transferred in any way to a
              third party. In the event of an account holder’s death, their
              Account will be closed, and their rewards (if any) will be
              cancelled.
            </p>

            <h3>3. Wallet</h3>
            <p>
              All data, including personal data, will be processed in accordance
              with our privacy policy and applicable data protecting laws and
              regulations. It will be shared with Service providers as required
              by the wallet programme. Valmeego’s wallets can only be used to
              pay for service’s in Valmeego.
            </p>
            <p>
              If you create an account on Valmeego a personal wallet will
              automatically be created. In addition, every trip created
              automatically has its own associated wallet for collecting and
              paying group expenses. Wallet transactions are processed by
              Stripe, Valmeego.com do not store or manage your bank details.{" "}
            </p>
            <p>
              <i>Your obligations: </i>
            </p>
            <ul>
              <li>
                You’re responsible for making sure that all information is
                correct, complete, and up to date.
              </li>
              <li>
                You may not use your wallet in any way this is misleading,
                unfair, or harmful.
              </li>
            </ul>
            <p>
              If you don’t adhere to the rules In this section, we may
              automatically suspend or cancel your wallet(s).
            </p>

            <h2>A.13 Intellectual property rights</h2>
            <p>
              Unless otherwise stated all rights in our platform (technology,
              content, trademarks, design. Etc) are owned by Valmeego.com and by
              using our platform you agree to do so for its intended purpose
              only and respecting the conditions set out below:
            </p>
            <p>
              You are not allowed to monitor, copy, scrape, download, reproduce,
              or otherwise use anything on our platform for any commercial
              purpose without the written permission of Valmeego.com or its
              licensors.{" "}
            </p>
            <p>
              We keep a close eye on every visit to our platform, and will block
              anyone (and any automated system) we suspect of:
            </p>
            <ul>
              <li>Conduct an unreasonable amount of searches</li>
              <li>
                Using any device or software to gather prices or other
                information
              </li>
              <li>Doing anything that places undue stress on our Platform</li>
            </ul>
            <p>
              By uploading any picture or video to our platform, you’re
              confirming that it complies with our criteria and that:
            </p>
            <ul>
              <li>It doesn’t contain any viruses</li>
              <li>You’re allowed to share it with us</li>
              <li>
                We’re allowed to use it on our platform and in relation to
                further commercial purposes (including any promotional context),
                everywhere, forever (when you let us know we can use it we will
                consider any such reasonable request)
              </li>
              <li>It doesn’t infringe the privacy rights of other people</li>
              <li>
                You accept full responsibility for any legal claims against
                Valmeego.com related to it
              </li>
            </ul>

            <p>
              To make it clear; we’re not responsible or liable for any picture
              or video uploaded to our platform, we’re allowed to remove any
              picture or video at our discretion. For instance, if we detect
              that a picture or video which does not meet the above criteria.
            </p>

            <h2>A.14 What if something went wrong</h2>
            <ol>
              <li>
                If you have a query or complaint, please contact our Customer
                Service team. You can do this by accessing your account through
                our application or. You can help us help you as quickly as
                possible - by providing:
                <ul>
                  <li>
                    {" "}
                    your Booking confirmation number, Service provider details,
                    your Valmeego account details and the email address you used
                    when you made your Booking{" "}
                  </li>
                  <li>
                    {" "}
                    a summary of the issue, including how you’d like us to help
                    you
                  </li>
                  <li>
                    {" "}
                    any supporting documents (bank statement, pictures,
                    receipts, etc.)
                  </li>
                </ul>
              </li>
              <li>
                All queries and complaints are recorded, and the most urgent
                ones are treated as highest priority.
              </li>
              <li>
                {" "}
                If you're a resident of the European Economic Area and you’re
                not happy with the way we handle your complaint, you may be able
                to complain via the European Commission's ODR (Online Dispute
                Resolution) platform (ec.europa.eu/odr).
                <ul>
                  It depends on what your complaint was about:
                  <li>
                    if it was about a service provider (accommodation,
                    attraction, transportation) you can use the ODR platform
                  </li>
                </ul>
              </li>
              <li>
                We do try to resolve disputes internally, and we’re not obliged
                to submit to any alternative dispute resolution procedures
                handled by independent providers.
              </li>
            </ol>

            <h2>A15. Communication with the Service Provider</h2>
            <p>
              We give you direct access to communicate with your service
              provider on our platform, we can’t guarantee that they’ll read or
              reply to you. The fact that you contact them, or that they contact
              you doesn’t mean you have grounds for legal action.
            </p>

            <h2>A.16 Meausres against unacceptable behaviour</h2>
            <p>
              We want Valmeego to be a place where people enjoy and feel safe
              planning their next travel trip, and are comfortable in sharing
              their past travel experiences, recommendations, and tips.{" "}
            </p>
            <ol>
              <li>
                We have the right to suspend your account(s), cancel your
                current activity or permanently disable access to your account
                if you failed to adhere to our policies or our values. We may
                also suspend or disable your account if you repeatedly infringe
                other people’s intellectual property rights to the point where
                we are required to do for legal reasons.
              </li>
              <li>
                We have the right to stop you making any Bookings, to cancel any
                Bookings you’ve already made, and/or to stop you using our
                Platform, our Customer Service, and your Account. Of course,
                we’ll only do this if, in our opinion, there’s a good reason to
                - for example:
                <ul>
                  <li>fraud or abuse</li>
                  <li>
                    non-compliance with Our values, or with applicable laws or
                    regulations
                  </li>
                  <li>
                    inappropriate or unlawful behaviour (e.g. violence, threats
                    or invasion of privacy) in relation to us, any of the
                    companies we work with – or anyone else, for that matter.
                  </li>
                </ul>
              </li>
            </ol>
            <p>
              If we cancel a Booking as a result, you won’t be entitled to a
              refund. We may tell you why we've cancelled your Booking, unless
              telling you would (a) contravene applicable laws and/or (b)
              prevent or obstruct the detection or prevention of fraud or other
              illegal activities. If you believe we have incorrectly cancelled
              your Booking, please contact our Customer Service team.
            </p>

            <h2>A17. Limitation of Liability</h2>
            <ol>
              <li>
                To the extent permitted by mandatory consumer law, we’ll only be
                liable for costs you incur as a direct result of a failure on
                our behalf. This means, to the extent permitted by law, we won’t
                be liable for (e.g.) any:{" "}
              </li>
              <ul>
                <li>indirect loss or indirect damage</li>
                <li>inaccurate information about a Service Provider</li>
                <li>
                  product, service or action of a Service Provider or other
                  business partner
                </li>
                <li>
                  mistake in an email address, phone number or credit card
                  number (unless it’s our fault)
                </li>
                <li>force majeure or event beyond our control.</li>
              </ul>
              <li>
                We will exercise professional diligence in providing our
                Products and services to you and in keeping a safe, secure, and
                error-free environment. Provided that we have acted with
                professional diligence, we do not accept responsibility for
                losses not caused by our breach of these Terms or otherwise by
                our acts; losses that are not reasonably foreseeable by you and
                us at the time of entering into these Terms; and events beyond
                our reasonable control.
              </li>
              <li>
                If you are in breach of these Terms and/or the Service
                Provider’s terms, to the extent permitted by law:
              </li>
              <ul>
                <li>
                  we won’t be liable for any costs you incur as a result, and
                </li>
                <li>you won’t be entitled to any refund.</li>
              </ul>

              <li>
                To the extent permitted by law, the most that we, or any Service
                Provider, will be liable for (whether for one event or a series
                of connected events) is the cost of your Booking, as set out in
                your confirmation booking(ticket).
              </li>
              <li>
                Nothing in these terms will limit our (or the Service
                Provider’s) liability in respect of our (or their) own (i)
                negligence that leads to death or personal injury or (ii) fraud
                or fraudulent misrepresentation.
              </li>
              <li>
                We don’t make any promises about Service Providers’ products and
                services (apart from what we expressly state in these Terms).
                Making the right choice(s) is entirely your responsibility.
              </li>
              <li>
                Just to make it clear: nothing in these Terms will entitle any
                third party other than the Service Provider to anything.
              </li>
              <li>
                You may be protected by mandatory consumer protection laws and
                regulations, which guarantee you rights that no company’s terms
                can overrule. In that case, our liability is determined not just
                by these Terms, but also by any applicable consumer protection
                laws and regulations
              </li>
            </ol>

            <h2>A18. Applicable law and forum</h2>
            <ol>
              <li>
                To the extent permitted by mandatory local (consumer) law, these
                Terms and our services will be governed by Irish law.
              </li>
              <li>
                To the extent permitted by mandatory local (consumer) law, any
                dispute will exclusively be submitted to the competent courts
                the Republic of Ireland.
              </li>
            </ol>

            <h2>B. Prodcuts and Services</h2>
            <h2>B1. The service we provide:</h2>
            <p>
              Our mission is to create a global network of local travel
              ecosystems. Creating value and business in local communities. To
              help advance this mission, we provide the products and services
              described below:
            </p>

            <ol>
              <li>
                <p>
                  <i>Personal experience for you, personal recommendations:</i>
                </p>
                <p>
                  Valmeego provides a unique experience for all its users. Our
                  network of local travel ecosystems provides value every day;
                  from ads, trips, local knowledge, and content that you see in
                  our travel feed. We use the data that we collect- for example,
                  the choices and settings you select, what features and tools
                  you prefer to use- to personalise your experience.
                </p>
              </li>

              <li>
                <p>
                  <i>Connect you with people/organisations:</i>
                </p>
                <p>
                  We help you find and connect with people (travellers), local
                  Ameego’s, Businesses, Destination Promoters and others that
                  matter to you across Valmeego. We allow our members to connect
                  with each other in Valmeego’s global ecosystem. For example-
                  Valmeego allows Trip Planner’s to create trips, invite their
                  trip members, and communicate with local Ameego’s to gain
                  local knowledge on their destination of choice.
                </p>
              </li>
              <li>
                <p>
                  <i>
                    Empower you to travel with knowledge and communicate about
                    your travel plans or interests:
                  </i>
                </p>
                <p>
                  Valmeego empowers people to plan their travel trips with ease
                  and enables them to communicate with all members of the Travel
                  Ecosystem- e.g. Businesses, Fellow travellers, Destination
                  promoters and Ameego’s. Share deals, events, knowledge,
                  photos, and videos in Valmeego’s travel feed. We provide users
                  with all the tools necessary to plan their trip from beginning
                  to end, using local knowledge
                </p>
              </li>
              <li>
                <p>
                  <i>
                    Help you discover deals/content/services that may interest
                    you:
                  </i>
                </p>
                <p>
                  We show you ads, offers, travel content, inspiration, and
                  posts of your friends to help you discover content and inspire
                  your trips. Ameego’s offer local knowledge to users who
                  request it, recommending places to stay and things to see or
                  do using the knowledge of a local. Have confidence in your
                  plans before you arrive in destination.
                </p>
              </li>
              <li>
                <p>
                  <i>
                    Combat harmful conduct + protect and support our ecosystem:
                  </i>
                </p>
                <p>
                  Valmeego aims to protect and support the members of our
                  ecosystem. We use an advanced technical system to detect
                  misuse of our services, harmful conduct towards others and
                  situations where we may be able to help support or protect our
                  ecosystem. If we learn of a member or content like this, we
                  will take appropriate action- for example, removing content,
                  disabling an account, or contacting law enforcement.
                </p>
              </li>
              <li>
                <p>
                  <i>
                    Integrates technology and human interaction to provide safe
                    and functional services for Valmeego members:
                  </i>
                </p>
                <p>
                  We use advanced technologies and human interaction to provide
                  a seamless platform for our uses. We believe that person to
                  person interaction is beneficial to its participants,
                  especially in travel. We provide a means of creating positive
                  experiences and memories in travel and hospitality which are
                  primarily the result of positive personal interactions.{" "}
                </p>
              </li>
              <li>
                <p>
                  <i>
                    Provide consistent and seamless experiences across
                    Valmeego’s platform
                  </i>
                </p>
                <p>
                  Our network of local travel ecosystems provides inspiration,
                  local knowledge, advice and deals directly from any
                  destinations. Our users have access to tools which connect
                  people, groups, businesses and Ameego’s. We design our systems
                  so that your experience is consistent and seamless across
                  Valmeego’s platforms.
                </p>
              </li>
              <li>
                <p>
                  <i>Enable global access to our services:</i>
                </p>
                <p>
                  To operate our global service, we need to store and distribute
                  content and data around the world, including outside your
                  country of residence. This infrastructure may be operated or
                  controlled by Valmeego.
                </p>
              </li>
            </ol>

            <h2>C. Service Providers</h2>
            <h2>C1. Scope of this Section</h2>
            <p>
              This section contains specific terms for Providers of Products and
              Services
            </p>

            <h2>C2. Contractual relationship</h2>
            <ol>
              <li>
                When you make a booking on Valmeego it’s directly with the
                Service Provider. We are not a ‘contractual party’ to your
                booking. We do not (re)sell, offer or provide any Products or
                Services on our own behalf - when you book you enter into a
                contract directly with the Service Provider.
              </li>
              <li>
                Valmeego.com owns and operates the Platform. We act solely as
                the Platform and are not involved in the Third-Party Terms. We
                are not responsible for your ticket and (to the fullest extent
                permitted by law) have no liability to you in relation to your
                Booking.
              </li>
              <li>
                Our Platform shows Service Providers that have a commercial
                relationship with us.{" "}
              </li>
              <li>
                Information about service providers (e.g. Facilities,
                sustainability measures) and their Travel Experiences (e.g.
                prices, availability and cancellation policies) is based on what
                they provide to us. They’re responsible for making sure it’s
                accurate and up to date.
              </li>
            </ol>

            <h2>C3. What we will do</h2>
            <ol>
              <li>
                We provide the Platform on which Service Providers can promote
                and sell their Service Providers – and you can search for,
                compare, and book them.
              </li>
              <li>
                Once you’ve booked your service, the Service Provider will
                provide you with details of your booking through Valmeego.
              </li>
              <li>
                Depending on the terms of your Booking, you may be able to
                change or cancel it through direct communication with the
                Service Provider.
              </li>
            </ol>

            <h2>C4. What you need to do</h2>
            <ol>
              <li>
                Create an account on Valmeego, fill in all your contact details
                correctly, so we and/or the Service Provider can provide you
                with information about your booking, and if necessary, contact
                you.
              </li>
              <li>
                Read these Terms and the terms displayed during the booking
                process carefully.
              </li>
            </ol>

            <h2>C5. Price and Payment</h2>
            <ol>
              <li>See ‘Prices’ (A6) and ‘Payment’ (A7) above.</li>
            </ol>

            <h2>C6. Amendments, cancellations, and refunds</h2>
            <ol>
              <li>See ‘Policies’ (A8) above.</li>
            </ol>
          </Col>
        </Row>
      </PageSection>
    </>
  );
};

Terms.Layout = Public;

export default Terms;
